import { toast } from "react-toastify";

// Service
import { vollmachtRequestFormService } from "../../services/vorgange/VollmachtRequestFormService";

// Constants
import { HTTP_SUCCESS_STATUS_CODES } from "../../../constants/VorgangDetailsConstants";
import {
  PREFILLED_DOCUMENTS_SUCCESS_DOWNLOAD,
  manualRequestFormConstants,
} from "../../../constants/ManualRequestFormConstants";

// Core components
import NotificationMessage from "../../../components/core/NotificationMessage";

function getRemoteIdentURL(requestId) {
  return () => {
    return vollmachtRequestFormService
      .getRemoteIdentURL(requestId)
      .then((resp) => {
        if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
          return resp?.data;
        }
      });
  };
}

function getPrefilledDocumentStatus(requestId) {
  return async () => {
    const resp = await vollmachtRequestFormService.getPrefilledDocumentStatus(
      requestId
    );
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      return resp?.data;
    }
  };
}

function getPrefilledDocumentsDownload(requestId) {
  return async () => {
    const resp =
      await vollmachtRequestFormService.getPrefilledDocumentsDownload(
        requestId
      );
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      toast.success(
        <NotificationMessage message={PREFILLED_DOCUMENTS_SUCCESS_DOWNLOAD} />
      );
      return resp;
    }
  };
}

function sendSignatureEmailDetails(
  vollmachtType = "PPOA",
  requestId,
  signedData
) {
  return async () => {
    const resp = await vollmachtRequestFormService.sendSignatureEmailDetails(
      vollmachtType,
      requestId,
      signedData
    );
    return resp;
  };
}

function getQESProviders() {
  return async (dispatch) => {
    const resp = await vollmachtRequestFormService.getQESProviders();
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      dispatch({
        type: manualRequestFormConstants.GET_QES_PROVIDERS_SUCCESS,
        resp,
      });
      return resp?.data;
    }
  };
}

function startQESSigning(requestId, vendorKey, personenform) {
  return async () => {
    const resp = await vollmachtRequestFormService.startQESSigning(
      requestId,
      vendorKey,
      personenform
    );
    if (HTTP_SUCCESS_STATUS_CODES?.includes(resp?.status)) {
      return resp?.data;
    }
  };
}

export const VollmachtRequestFormAction = {
  getRemoteIdentURL,
  getPrefilledDocumentStatus,
  getPrefilledDocumentsDownload,
  sendSignatureEmailDetails,
  getQESProviders,
  startQESSigning,
};
